import { render } from "./BarProgress2.vue?vue&type=template&id=7ec92789"
import script from "./BarProgress2.vue?vue&type=script&lang=js"
export * from "./BarProgress2.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__